import { render, staticRenderFns } from "./MapLocationCard.vue?vue&type=template&id=2da1d6f0&scoped=true"
import script from "./MapLocationCard.vue?vue&type=script&lang=js"
export * from "./MapLocationCard.vue?vue&type=script&lang=js"
import style0 from "./MapLocationCard.vue?vue&type=style&index=0&id=2da1d6f0&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2da1d6f0",
  null
  
)

export default component.exports